export const SUPPORTS_OBJECT_PROTOTYPE_PROPERTY_IS_ENUMERABLE = "propertyIsEnumerable" in Object.prototype;
